import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppsComponent } from './apps.component';
import { AppsResolver } from './apps.resolver';
import { FinalizeComponent } from '../finalize/finalize.component';
import { AppKey } from './app/app';
import { YelpZapierCallbackComponent } from './app/yelp-zapier-setup/yelp-zapier-callback.component';

const routes: Routes = [
  {
    path: '', component: AppsComponent, resolve: { availableApps: AppsResolver },
    runGuardsAndResolvers: 'pathParamsChange'
  },
  {
    // GoHighLevel rejects redirect URIs that reference its brand ("highlevel", "ghl"),
    // so its OAuth callback lands on this neutral alias instead of finalize/gohighlevel.
    path: 'finalize/location-crm', component: FinalizeComponent, resolve: { availableApps: AppsResolver },
    data: { finalizeAppKey: AppKey.GoHighLevel },
  },
  {
    path: 'finalize/:id', component: FinalizeComponent, resolve: { availableApps: AppsResolver },
  },
  {
    path: 'yelp-zapier', component: YelpZapierCallbackComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppsRoutingModule {
}
